import { FaPenToSquare, FaQrcode, FaRightFromBracket, FaTrashCan, FaWhatsapp } from "react-icons/fa6";
import { WaCardSkeleton } from "./components/skeleton";
import { WaTableEmptyState } from "../table/components/empty_state";
import { formatPhoneNumber } from "../../../../../../utilities/formatNumber";
import { WaNumberStatusBadge } from "../../components/status_badge";

export const WaDeviceCardSection = ({ data, loading, refreshData }) => {
    return (
        <>
            <section
                className="lg:hidden space-y-3"
                aria-label="Daftar Perangkat WhatsApp"
            >
                {loading ? (
                    <div className="space-y-3">
                        <WaCardSkeleton />
                        <WaCardSkeleton />
                        <WaCardSkeleton />
                    </div>
                ) : !data || data.length === 0 ? (
                    <div
                        className="rounded-2xl border"
                        style={{
                            background: "rgba(15, 23, 42, 0.4)",
                            borderColor: "rgba(51, 65, 85, 0.3)",
                        }}
                    >
                        <WaTableEmptyState />
                    </div>
                ) : (
                    <div className="space-y-3">
                        {data.map((item, index) => {
                            const isConnected = item?.status === "Connected";
                            return (
                                <>
                                    <div
                                        className="rounded-2xl p-4 border transition-all duration-200 hover:border-slate-600/40"
                                        style={{
                                            background: "rgba(15, 23, 42, 0.4)",
                                            borderColor: "rgba(51, 65, 85, 0.3)",
                                        }}
                                    >
                                        <div className="flex items-start justify-between mb-3">
                                            <div className="flex items-center gap-3 min-w-0">
                                                <div
                                                    className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${isConnected
                                                            ? "bg-emerald-500/10 border border-emerald-500/15"
                                                            : "bg-slate-800/60 border border-slate-700/40"
                                                        }`}
                                                >
                                                    <FaWhatsapp
                                                        className={`text-lg ${isConnected
                                                                ? "text-emerald-400"
                                                                : "text-slate-600"
                                                            }`}
                                                    />
                                                </div>
                                                <div className="min-w-0">
                                                    <h4 className="text-sm font-bold text-gray-100 truncate">
                                                        {item?.name || "-"}
                                                    </h4>
                                                    <p className="text-xs text-slate-500 font-mono mt-0.5">
                                                        {formatPhoneNumber(item?.phone_number)}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="shrink-0 ml-2">
                                                <WaNumberStatusBadge status={item?.status} />
                                            </div>
                                        </div>

                                        {/* 4 Tombol Aksi — Mobile */}
                                        <div className="grid grid-cols-4 gap-2 pt-3 border-t border-slate-800/50">
                                            <button
                                                // onClick={() => handleOpenScan(item)}
                                                className={`flex items-center justify-center gap-1 py-2 rounded-xl text-[10px] font-bold transition-all border whitespace-nowrap ${isConnected
                                                        ? "bg-amber-500/8 text-amber-400 border-amber-500/15 hover:bg-amber-500/15"
                                                        : "bg-cyan-500/8 text-cyan-400 border-cyan-500/15 hover:bg-cyan-500/15"
                                                    }`}
                                            >
                                                <FaQrcode size={10} className="shrink-0" />
                                                <span>{isConnected ? "Scan" : "Scan"}</span>
                                            </button>
                                            <button
                                                // onClick={() => handleOpenUpdate(item)}
                                                className="flex items-center justify-center gap-1 py-2 rounded-xl text-[10px] font-bold transition-all border bg-blue-500/8 text-blue-400 border-blue-500/15 hover:bg-blue-500/15"
                                            >
                                                <FaPenToSquare size={10} className="shrink-0" />
                                                <span>Update</span>
                                            </button>
                                            {isConnected ? (
                                                <button
                                                    // onClick={() => handleOpenLogout(item)}
                                                    className="flex items-center justify-center gap-1 py-2 rounded-xl text-[10px] font-bold transition-all border bg-amber-500/8 text-amber-400 border-amber-500/15 hover:bg-amber-500/15"
                                                >
                                                    <FaRightFromBracket
                                                        size={10}
                                                        className="shrink-0"
                                                    />
                                                    <span>Logout</span>
                                                </button>
                                            ) : (
                                                <div />
                                            )}
                                            <button
                                                // onClick={() => handleOpenDelete(item)}
                                                className="flex items-center justify-center gap-1 py-2 rounded-xl text-[10px] font-bold transition-all border bg-slate-700/30 text-slate-400 border-slate-600/30 hover:bg-red-500/10 hover:text-red-400 hover:border-red-500/20"
                                            >
                                                <FaTrashCan size={10} className="shrink-0" />
                                                <span>Hapus</span>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )
                        })}
                    </div>
                )}
            </section>
        </>
    )
}